export default __webpack_public_path__ + "static/media/VIP_Member_icon.a7b56099.svg";